import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { DockBrief, DockOverview } from '../models';
import { HubEndpoint } from '../../hub/constants/hub-endpoint';
import { CompartmentEndpoint } from '../../compartment/constants/compartment-endpoint';
import { DockEndpoint } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class DockItemService {
  constructor(private http: WrapperHttpService) {}

  createNewDock(hubId: number, compartmentId: number, dockOverview: DockOverview): Observable<DockOverview> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}`;
    return this.http.withLoading().post<DockOverview>(url, dockOverview);
  }

  updateDock({
    hubId,
    compartmentId,
    dockOverview,
  }: {
    hubId: number;
    compartmentId: number;
    dockOverview: DockOverview;
  }): Observable<DockOverview> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}`;
    return this.http.withLoading().post<DockOverview>(url, dockOverview);
  }

  getDockQr({
    hubId,
    compartmentId,
    dockId,
  }: {
    hubId: number;
    compartmentId: number;
    dockId: number;
  }): Observable<string> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}/${dockId}${DockEndpoint.Qr}`;
    return this.http.withLoading().get<string>(url, {
      responseType: 'text',
    });
  }

  deleteDocks(hubId: number, compartmentId: number, dockIdList: number[]): Observable<DockBrief> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${DockEndpoint.Base}`;
    return this.http.withLoading().delete<DockBrief>(url, { body: dockIdList });
  }
}
